import { render, staticRenderFns } from "./zWeb.vue?vue&type=template&id=87a48262&scoped=true"
import script from "./zWeb.vue?vue&type=script&lang=js"
export * from "./zWeb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87a48262",
  null
  
)

export default component.exports